<mat-sidenav-container [hasBackdrop]="false"
                       (backdropClick)="handleGracefulClose()">
  <mat-sidenav #sidenavRight mode="side" position="end"
               class="admin-feature-sidenav-no-scrollbar"
               [fixedInViewport]="true"
               [fixedTopGap]="56"
               [fixedBottomGap]="0"
               [opened]="false"
               (keydown.escape)="handleGracefulClose()"
               disableClose
               style="width: 400px">
    <app-crud-item
      [title]="formTitle"
      [subtitle]="formSubtitle"
      [(data)]="selectedRow"
      [modelType]="modelType"
      [apiEndpoint]="apiEndpointPOST"
      (onFormSubmitted)="handleFormSubmission($event)"
    >
    </app-crud-item>
  </mat-sidenav>


  <mat-sidenav-content>
    <app-crud-table
      [title]='tableTitle'
      [subTitle]='tableSubtitle'
      [modelType]="modelType"
      [apiEndpointRoot]="apiEndpointRoot"
      [loading$]="loading$"
      [updatedRow]="updatedRow"
      [additionalActions]="additionalActions"
      [interruptPendingChanges]="pendingChanges"
      (rowSelected)="rowSelected($event)"
    ></app-crud-table>
  </mat-sidenav-content>
</mat-sidenav-container>
